import { createSafeContext } from '@mews/framework';
import { SelectedRateGroup } from '../types';

export const { CurrentRateGroupContextProvider, useCurrentRateGroupContext } = createSafeContext<
    'CurrentRateGroupContext',
    SelectedRateGroup
>('CurrentRateGroupContext');
